// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-3904df6e] {\n  --magic-box-background: var(--magic-tertiary, #311261);\n}\n\n.title[data-v-3904df6e] {\n  color: var(--magic-light, #fff);\n}\n\n.body[data-v-3904df6e] {\n  color: var(--magic-light, #fff);\n}\n.body--tnc[data-v-3904df6e] {\n  color: var(--magic-light, #fff);\n}\n\n.accordion[data-v-3904df6e] {\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
